import React from 'react'
import i18n from 'i18n'

export default async function getMenuData() {
  const menuList = [
    {
      title: 'Main',
      key: 'menu-main',
      url: '/main',
      icon: null,
    },
    {
      title: 'Menu-1',
      key: 'menu-1',
      url: '/main',
      icon: null,
    },
    {
      title: 'Menu-2',
      key: 'menu-2',
      url: '/main',
      icon: null,
    },
    {
      title: i18n.t('menu.chat'),
      key: 'menu-3',
      url: '/main',
      icon: null,
    },
  ]

  return menuList
}
